import styled from 'styled-components';


export const Wrapper = styled.div`
  position: relative;
  font-size: 16px;
  width: 100%;
  > .typo__header {
    margin-bottom: 10px;
    @media (min-width: 800px) {
      max-width: none;
      text-align: center;
    }
  }
`;


export const Context = styled.div`
  margin: 10px 0 40px;
   
  &:last-child {
    margin: 10px 0 0;
  }

  .item-block {
    margin-bottom: 40px;
   &:last-child {
    margin-bottom: 0;
  }
    .image-container {
      display: flex;
      width: 100%;
      flex-direction: row;
      gap: 5px;
      
      .image-item {
        width: 100%;
        max-width: 100%;
        position: relative;
        overflow: hidden;
          img {
            width: 100%;
            max-width: 100%;
            height: auto;
          }

          .image-label {
            font-size: 14px;
            text-align: center;
            width: 100%;
          }
      }
    }

    .copy-title {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-weight: 500;
      font-size: 18px;
    }
  }
`;
